import { useMemo } from 'react';

import { useGetTranslation } from '@travel/traveler-core/hooks';

export type SelectBoxOption = { labelId?: string; value: string };

/**
 * to convert given config with labelId to SelectBox options (memoize)
 * @param configArray - options with labelId and value
 * @param withUnSelectedOption - Flag to defind whether the default option will be added or not
 */
const useLabelSelectBoxOptions = <T extends SelectBoxOption>(
  configArray: Array<T>,
  withUnSelectedOption: boolean = false,
) => {
  const getTranslation = useGetTranslation();

  const options = useMemo(
    () =>
      configArray?.map(item => ({
        ...item,
        text: getTranslation({ id: item.labelId || '' }),
      })) || [],
    [configArray],
  );

  return withUnSelectedOption ? [{ text: '---', value: '' }, ...(options || [])] : options;
};

export default useLabelSelectBoxOptions;
